export const CARD_PATTERNS = {
  visa: {
    pattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
    format: '#### #### #### ####',
    maxLength: 16,
  },
  mastercard: {
    pattern: /^5[1-5][0-9]{14}$/,
    format: '#### #### #### ####',
    maxLength: 16,
  },
  amex: {
    pattern: /^3[47][0-9]{13}$/,
    format: '#### ###### #####',
    maxLength: 15,
  },
};

export const formatCardNumber = (value: string, cardType: string = 'visa'): string => {
  if (!value) return '';

  const cardConfig = CARD_PATTERNS[cardType as keyof typeof CARD_PATTERNS] || CARD_PATTERNS.visa;
  const digits = value.replace(/\D/g, '');
  const format = cardConfig.format;

  let formattedValue = '';
  let digitIndex = 0;

  for (let i = 0; i < format.length && digitIndex < digits.length; i++) {
    if (format[i] === '#') {
      formattedValue += digits[digitIndex++];
    } else {
      formattedValue += format[i];
    }
  }

  return formattedValue;
};

export const validateCardNumber = (value: string, cardType: string = 'visa'): boolean => {
  if (!value) return false;

  const cardConfig = CARD_PATTERNS[cardType as keyof typeof CARD_PATTERNS] || CARD_PATTERNS.visa;
  const digits = value.replace(/\D/g, '');

  return digits.length === cardConfig.maxLength;
};

export const getCardType = (value: string): string => {
  if (!value) return 'visa';

  const digits = value.replace(/\D/g, '');

  if (CARD_PATTERNS.visa.pattern.test(digits)) return 'visa';
  if (CARD_PATTERNS.mastercard.pattern.test(digits)) return 'mastercard';
  if (CARD_PATTERNS.amex.pattern.test(digits)) return 'amex';

  return 'visa';
};
